export enum PocTypeEnum {
    NoRGB = 1,
    RGB = 2
}

export enum PocSegmentTypeEnum {
    Core = 1,
    Premium = 2
}
